import React from "react";

import { Button } from "../../../components/button";
import { SiteInput } from "../../sites/components";
import { useCreateUserSite } from "../hooks";
import { toast } from "react-toastify";
import { CardHeader } from "../../../components/cards";

interface IUserSiteForm {
  userId: number;
}

export const UserSiteForm: React.FC<IUserSiteForm> = ({ userId }) => {
  const { form, submit, loading } = useCreateUserSite({
    defaultValues: {
      userId,
    },
    onCompleted: () => {
      toast.success("");
    },
  });

  return (
    <div className="w-full">
      <div className="card mb-2">
        <CardHeader title="Ajouter un site" />
        <div className="w-full mb-2">
          <SiteInput form={form} />
        </div>
        <div className="w-full mb-2 justify-center items-center">
          <Button loading={loading} onClick={submit}>
            Valider
          </Button>
        </div>
      </div>
    </div>
  );
};
